import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const Cookies = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <div className="min-h-screen pt-32 pb-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">{t.cookies.title}</h1>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-6">{t.cookies.content}</p>
            
            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Çerezler Nedir?' : 'What are Cookies?'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Çerezler, web sitelerini ziyaret ettiğinizde cihazınıza kaydedilen küçük metin dosyalarıdır. Çerezler, web sitesinin daha verimli çalışmasını sağlar ve site sahiplerine bilgi sağlar.'
                : 'Cookies are small text files saved to your device when you visit websites. Cookies enable the website to work more efficiently and provide information to site owners.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Çerez Türleri' : 'Types of Cookies'}
            </h2>
            <p className="text-gray-600 mb-4">
              {language === 'tr'
                ? 'Zorunlu Çerezler: Web sitesinin temel işlevlerini yerine getirmesi için gereklidir. Performans Çerezleri: Ziyaretçilerin siteyi nasıl kullandığını anlamamıza yardımcı olur. İşlevsellik Çerezleri: Tercihlerinizi hatırlayarak daha kişiselleştirilmiş bir deneyim sunar.'
                : 'Essential Cookies: Necessary for the website to perform basic functions. Performance Cookies: Help us understand how visitors use the site. Functionality Cookies: Remember your preferences to provide a more personalized experience.'}
            </p>

            <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">
              {language === 'tr' ? 'Çerezleri Kontrol Etme' : 'Controlling Cookies'}
            </h2>
            <p className="text-gray-600">
              {language === 'tr'
                ? 'Tarayıcı ayarlarınızdan çerezleri kabul etmeyi veya reddetmeyi seçebilirsiniz. Ancak bazı çerezlerin engellenmesi, web sitesinin bazı özelliklerini kullanmanızı etkileyebilir.'
                : 'You can choose to accept or decline cookies from your browser settings. However, blocking some cookies may affect your use of some features of the website.'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
